import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg display="inline-block" height="11" width="11" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5.33 4.13L6.83 5.6l2.75-2.75L11 4.29V0H6.71l1.38 1.38zM10.96 6L9.9 4.95V9.9H1.1V1.1h4.95L4.95 0H1.1C.5 0 0 .5 0 1.1v8.8c0 .6.5 1.1 1.1 1.1h8.8c.6 0 1.1-.5 1.1-1.1z" fill="#388fda" /></svg>);